import React from 'react';
import Select from 'react-select';
import ReactToggle from 'react-toggle';
import BuilderActions from '../builder/action/builderActions';
import panelActions from '../panel/action/panelActions';
import PreQuery from './prequery';
import clone from 'clone';

class AppearPanel extends React.Component {
  constructor(props) {
    super(props);
    this.displayName = 'AppearPanel';
    this.saveSettings = this.saveSettings.bind(this);
    this.handleChangeTheme = this.handleChangeTheme.bind(this);
    this.handleTaxonomySelection = this.handleTaxonomySelection.bind(this);
    this.selectPrequery = this.selectPrequery.bind(this);
    this.postTypesHelper = API.helper.all_post_types ? API.helper.all_post_types : ['post'];
    this.postTypeOptions = [];
    this.postTypesHelper.forEach((type) => {
      this.postTypeOptions.push({
        value: type,
        label: type,
      });
    });
    const dummy = {
      theme: 'reactive',
      post_type: 'post',
      ajax: 'false',

    };
    this.state = {
      data: this.props.settingsData.hasOwnProperty('post_type') ? this.props.settingsData : dummy,
      defaultTaxonomy: [],
      defaultMeta: [],
    };
  }
  componentWillMount() {
    const settingsData = clone(this.props.settingsData);
    let defaultTaxonomy = [];
    let defaultPrequery = '';
    if (settingsData.hasOwnProperty('prequery')) {
      if (settingsData.prequery.hasOwnProperty('taxonomy')) {
        defaultTaxonomy = clone(settingsData.prequery.taxonomy);
      }
      if (settingsData.prequery.hasOwnProperty('defaultPrequery')) {
        defaultPrequery = settingsData.prequery.defaultPrequery;
      }
    }
    this.setState({ defaultTaxonomy, defaultPrequery });
  }
  handleChangeTheme(option) {
    const { data } = this.state;
    data['theme'] = option;
    this.setState({ data });
  }
  handleTaxonomySelection(value) {
    this.setState({ defaultTaxonomy: value });
  }
  selectPrequery(value) {
    this.setState({ defaultPrequery: value });
  }
  saveSettings() {
    const data = clone(this.state.data);
    data['prequery'] = {};
    if (this.state.defaultTaxonomy !== undefined) {
      data['prequery'].taxonomy = this.state.defaultTaxonomy;
    }
    if (this.state.defaultPrequery !== undefined && this.state.defaultPrequery.length !== 0) {
      data['prequery'].defaultPrequery = this.state.defaultPrequery;
    }
    const pushLayout = {
      'settingsData': data,
      'shortcodeKey': this.props.shortcodeKey,
    };
    BuilderActions.saveSettingsData(pushLayout);
    this.props.onClickedPanel();
  }

  render() {
    // processing themes into array
    const themes = [];
    if (window.ReactiveTheme) {
      for (const theme in window.ReactiveTheme) {
        themes.push(theme);
      }
    }

    const { data } = this.state;
    const settings = clone(this.props.settingsData);
    let showPreQuery = false;
    if (settings.hasOwnProperty('post_type')) {
      showPreQuery = true;
    }
    const showThemes = (theme, index) => {
      let checked = false;
      if (data.theme === theme) {
        checked = true;
      }
      return (<li className="search-content" key={'appearpanel-' + index}>
        <input type="radio" name="search-markerElement" checked={checked} id={'theme-' + index} value={theme}
          onChange={this.handleChangeTheme.bind(this, theme)}
        />
        <label className="select-search-content" htmlFor={'theme-' + index}>
          <span>{theme}</span>
        </label>
      </li>);
    };

    return (<div>
      <div className="flex-row">
        <div className="flex-sm-12 flex-xs-12">

         <div className="reactive-tab-setting">
            <ul className="nav nav-tabs" role="tablist">
              <li role="presentation" className="active"><a href="#settingsGeneral" aria-controls="general" role="tab" data-toggle="tab">{API.LANG.SETTINGS}</a></li>
              {showPreQuery ? <li role="presentation"><a href="#settingsLayout" aria-controls="layout" role="tab" data-toggle="tab">{API.LANG.PREQUERY}</a></li> : null}
            </ul>
            <div className="tab-content">
              <div role="tabpanel" className="tab-pane active" id="settingsGeneral">
                <div className="grid-choose-option">
                  <div className="flex-row">
                    <div className="grid-choose-option smallmargin ">
                      <span className="caption">{API.LANG.SELECT_THEME}</span>
                      <div>
                        <ul className="list-inline">{ themes.map(showThemes) }</ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              { showPreQuery === true ?
              <div role="tabpanel" className="tab-pane" id="settingsLayout">
                <div className="grid-choose-option">
                  <div className="flex-row">
                    <pre>{API.LANG.PREQUERY_AJAX_WARNING}</pre>
                    <PreQuery {...this.props} defaultTaxonomy={this.state.defaultTaxonomy} selectPrequery={this.selectPrequery}
                      defaultPrequery={this.state.defaultPrequery}
                      handleTaxonomySelection={this.handleTaxonomySelection}
                    />
                  </div>
                </div>
              </div> : null}
            </div>
          </div>
          {
            /** **/
          }

        </div>
      </div>
      <div className="add-button-content-settings">
        <a href="#" className="add-button" onClick={this.saveSettings} > {API.LANG.SAVE} </a>
      </div>

    </div>);
  }
}


AppearPanel.propTypes = {
  'onClickedPanel': React.PropTypes.func,
  settingsData: React.PropTypes.object,
};

export default AppearPanel;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/panel/appearPanel.js
 **/